(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aheata-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var heroes = document.querySelectorAll('.ah-hero');
  heroes.forEach(function (hero) {
    if (hero.dataset.ahInit) return;
    hero.dataset.ahInit = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = document.documentElement;
    var glowConfigs = {
      low:  { hue: 262, sat: '62%', strength: 0.42 },
      med:  { hue: 335, sat: '75%', strength: 0.52 },
      high: { hue: 353, sat: '90%', strength: 0.78 }
    };
    var emberRate = 1, emberHueBase = 335, currentTemp = null;
    var tempEl = hero.querySelector('.ah-temp-readout .deg');
    var runEl = hero.querySelector('.ah-runtime');
    if (tempEl) currentTemp = parseInt(tempEl.textContent, 10) || 120;

    hero.querySelectorAll('.ah-heat-buttons button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        hero.querySelectorAll('.ah-heat-buttons button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var cfg = glowConfigs[btn.dataset.level];
        root.style.setProperty('--ah-glow-hue', cfg.hue);
        root.style.setProperty('--ah-glow-sat', cfg.sat);
        root.style.setProperty('--ah-glow-strength', cfg.strength);
        emberHueBase = cfg.hue;
        emberRate = btn.dataset.level === 'high' ? 2.2 : btn.dataset.level === 'med' ? 1 : 0.45;
        if (runEl) runEl.textContent = 'UP TO ' + btn.dataset.hrs + ' HRS RUNTIME';
        if (tempEl) animateTemp(parseInt(btn.dataset.temp, 10));
      });
    });

    function animateTemp(target) {
      var start = currentTemp, dur = 700, t0 = performance.now();
      function tick(t) {
        var p = Math.min((t - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        currentTemp = Math.round(start + (target - start) * eased);
        tempEl.textContent = currentTemp;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var canvas = hero.querySelector('.ah-embers');
    if (canvas && !reduced) {
      var ctx = canvas.getContext('2d');
      var embers = [];
      function size() { canvas.width = hero.offsetWidth; canvas.height = hero.offsetHeight; }
      size();
      window.addEventListener('resize', size);
      function spawn() {
        embers.push({
          x: Math.random() * canvas.width, y: canvas.height + 10,
          r: Math.random() * 2.4 + 0.7,
          vy: -(Math.random() * 0.9 + 0.45), vx: (Math.random() - 0.5) * 0.5,
          life: 1, decay: Math.random() * 0.004 + 0.002,
          hue: emberHueBase + (Math.random() * 30 - 15)
        });
      }
      (function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (Math.random() < 0.25 * emberRate) spawn();
        embers = embers.filter(function (e) { return e.life > 0 && e.y > -20; });
        embers.forEach(function (e) {
          e.x += e.vx + Math.sin(e.y * 0.015) * 0.35;
          e.y += e.vy; e.life -= e.decay;
          ctx.beginPath();
          ctx.arc(e.x, e.y, e.r, 0, Math.PI * 2);
          ctx.fillStyle = 'hsla(' + e.hue + ',85%,62%,' + e.life * 0.85 + ')';
          ctx.shadowBlur = 8;
          ctx.shadowColor = 'hsla(' + e.hue + ',90%,55%,' + e.life + ')';
          ctx.fill();
          ctx.shadowBlur = 0;
        });
        requestAnimationFrame(draw);
      })();
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.ah-reveal').forEach(function (el) { io.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aheata-specs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      en.target.querySelectorAll('.ah-spec-val').forEach(function (v) {
        var target = parseFloat(v.dataset.count);
        var dec = parseInt(v.dataset.decimal || 0, 10);
        var small = v.querySelector('small');
        var suffix = small ? small.outerHTML : '';
        if (reduced) { v.innerHTML = target.toFixed(dec) + suffix; return; }
        var t0 = performance.now(), dur = 1400;
        (function tick(t) {
          var p = Math.min((t - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          v.innerHTML = (target * eased).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('.ah-spec-grid').forEach(function (g) { io.observe(g); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
